import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useTheme } from "@mui/material/styles";
import { getAuthGlassFieldSx } from "./authGlassStyles";

/**
 * Shared password TextField with a 44×44 show/hide icon button.
 * Passes through all standard TextField props plus:
 *   showPsw   — controlled boolean
 *   onToggle  — callback to flip showPsw
 */
export default function AuthPasswordField({ showPsw, onToggle, sx, ...rest }) {
  const theme = useTheme();
  const { InputProps: userInputProps, sx: restSx, ...other } = rest;
  return (
    <TextField
      {...other}
      variant="outlined"
      type={showPsw ? "text" : "password"}
      InputProps={{
        style: { height: 48 },
        ...userInputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              type="button"
              aria-label={showPsw ? "Hide password" : "Show password"}
              onClick={onToggle}
              onMouseDown={(e) => e.preventDefault()}
              tabIndex={-1}
              edge="end"
              sx={{ width: 44, height: 44 }}
            >
              {showPsw ? (
                <VisibilityOffIcon sx={{ fontSize: 20 }} />
              ) : (
                <VisibilityIcon sx={{ fontSize: 20 }} />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={[getAuthGlassFieldSx(theme), restSx, sx].filter(Boolean)}
    />
  );
}
